export default function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden py-6 select-none" aria-hidden="true">
      <div className="marquee-track items-center gap-16">
        {row.map((item, i) => (
          <span
            key={i}
            className={`flex items-center gap-16 whitespace-nowrap font-display text-2xl sm:text-3xl font-semibold tracking-tight ${dark ? 'text-white/25' : 'text-[#10282C]/20'}`}
          >
            {item}
            <span className={`w-2 h-2 rounded-full ${dark ? 'bg-[#00C5C2]/40' : 'bg-[#00918F]/30'}`} />
          </span>
        ))}
      </div>
    </div>
  );
}
